import React, {Fragment, useState} from 'react';
import styled from 'styled-components';
import TYPES from './orderTableTypes';
import {ArrowDropUp, ArrowDropDown} from '@styled-icons/material';
import Image from '../Image';
import StatusBar from './StatusBar';
import {Table} from 'antd';
const appConfig = require('../../data.json');

export default function LargeScreenTable({
  orders,
  loading,
  columns,
  filters,
  setFilters,
  total,
  noPage = false,
}) {
  return (
    <Wrapper>
      <Table
        locale={{
          emptyText: (
            <Image
              src="/images/empty-order.svg"
              height="80"
              width="80"
              alt="empty order"
            />
          ),
        }}
        loading={loading}
        columns={columns}
        expandable={
          filters.type === TYPES.NORMAL
            ? {
                expandedRowRender: (record) => <StatusBar order={record} />,
                rowExpandable: (record) => true,
                expandIcon: ({expanded, onExpand, record}) =>
                  expanded ? (
                    <ArrowDropUp
                      color={'#aaa'}
                      size={20}
                      onClick={(e) => onExpand(record, e)}
                    />
                  ) : (
                    <ArrowDropDown
                      color={'#aaa'}
                      size={20}
                      onClick={(e) => onExpand(record, e)}
                    />
                  ),
                expandIconColumnIndex: 6,
              }
            : false
        }
        dataSource={orders.map((order, idx) => {
          order.key = idx;
          return order;
        })}
        pagination={
          noPage
            ? false
            : {
                total: total,
                pageSize: filters.pageSize,
                current: filters.current,
              }
        }
        onChange={(pagination) => {
          setFilters({
            pageSize: pagination.pageSize,
            current: pagination.current,
          });
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & .ant-table-content {
    border: solid 1px #ccc;
    border-radius: 4px;
  }
  & .ant-table-thead > tr > th {
    background-color: #fafafa;
    color: #505050;
    border-bottom: solid 1px #ccc;
  }
  & .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 15px 15px;
  }
`;
